import script from "./goRinSyo0064.vue?vue&type=script&setup=true&lang=js"
export * from "./goRinSyo0064.vue?vue&type=script&setup=true&lang=js"

import "./goRinSyo0064.vue?vue&type=style&index=0&id=1b5025fe&lang=scss"

const __exports__ = script;

export default __exports__